<template>
    <div v-if="isVisible" class="ag-button-container">
        <v-btn variant="outlined" class="ag-btn" @click="onClick">
            {{ params.text }}
        </v-btn>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { has } from 'lodash';

export default defineComponent({
    computed: {
        isVisible() {
            return has(this.params, 'visible') ? this.params.visible(this.params) : true;
        },
    },

    methods: {
        onClick() {
            this.params.onClick(this.params);
            if (this.params.node) {
                this.params.api.refreshCells({ rowNodes: [this.params.node] });
            } else {
                this.params.api.refreshCells();
            }
        },
    },
});
</script>

<style scoped lang="scss">
@import '@style/base/_variables.scss';
.ag-button-container {
    display: flex;
    flex-direction: column;
}
</style>
